<div
  class="multiple-select-control"
  cdkTrapFocus
  [cdkTrapFocusAutoCapture]="true"
  (keydown.escape)="closed.emit()"
  tabindex="0"
>
  @if (inputData.matchOptions?.length) {
    <div class="match-mode">
      <span>{{ fieldName }}</span>
      <select
        [ngModel]="matchMode"
        aria-label="{{ fieldName }}の条件"
        (ngModelChange)="onMatchModeChange($event)"
      >
        @for (option of inputData.matchOptions; track option.value) {
          <option [value]="option.value">{{ option.label }}</option>
        }
      </select>
    </div>
  }
  <mat-checkbox
    [checked]="selectAll"
    (change)="onSelectAll($event)"
    [disabled]="this.disableSelectAll"
    ><div class="select-all-label">すべて選択</div></mat-checkbox
  >
  @for (item of filteredItems; track item) {
    <mat-checkbox
      [checked]="item.checked"
      [disabled]="item.notSelectable"
      (change)="onSelect(item, $event)"
    >
      <div class="item-label">
        {{ item.label }}
      </div>
    </mat-checkbox>
  }
</div>
